<template>
<div class="fission np-marketing-analysis">
    <div class="total bgc">
        <div class="left">
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <el-tooltip content="活动的浏览人数，同一个人多次访问算 1 次" placement="top">
                            <div class="name">
                                <span>总用户数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-blue">{{layerinfo.uviewcount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip content="活动的全部成交订单数" placement="top">
                            <div class="name">
                                <span>总订单数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-green">{{layerinfo.totalordercount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip content="最大裂变层级" placement="top">
                            <div class="name">
                                <span>裂变层级</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{layerinfo.maxlayer}}</div>
                    </div>
                </div>
            </div>
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的用户数'" placement="top">
                            <div class="name">
                                <span>时段用户数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-blue">{{summaryinfo.usercount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的订单数'" placement="top">
                            <div class="name">
                                <span>时段订单数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-green">{{summaryinfo.ordercount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的最大裂变层级'" placement="top">
                            <div class="name">
                                <span>时段裂变层级</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{summaryinfo.maxlayer}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="filters bgc">
                <div class="add">
                    <el-button type="danger" @click="handleQuery(1)" :class="[param.timetype!=1?'is-disabled': '']">今天</el-button>
                    <el-button type="primary" @click="handleQuery(2)" :class="[param.timetype!=2?'is-disabled': '']">昨天</el-button>
                    <el-button type="success" @click="handleQuery(3)" :class="[param.timetype!=3?'is-disabled': '']">近7天</el-button>
                    <el-button type="warning" @click="handleQuery(4)" :class="[param.timetype!=4?'is-disabled': '']">近30天</el-button>
                </div>
                <div class="search">
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" plain @click="handleQuery(0)">确认筛选</el-button>
                    <el-button type="primary" plain @click="handleExport">下载表格</el-button>
                </div>
            </div>
            <div>
                <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
            </div>
        </div>
    </div>
    <div class="list">
        <div class="dateTime blod"><span class="blod">{{summaryinfo.begindate}}</span> 至 <span class="blod">{{summaryinfo.enddate}}</span></div>
        <div class="result-list btn-operate-list bgc">
            <el-table :data="tableData" style="width: 100%" border>
                <el-table-column prop="date" label="时间" class-name="center">
                    <template slot-scope="scope">
                        <div class="layerdata-item"><div class="box">{{scope.row.date}}</div></div>
                    </template>
                </el-table-column>
                <el-table-column label="裂变层数" class-name="center">
                    <template>
                        <div class="layerdata-item">
                            <div class="box">UV数</div>
                            <div class="box">订单数</div>
                            <div class="box">转化率</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-for="(i) in layerinfo.maxlayer" :key="i" prop="layerdata" :label="(i)+''">
                    <template slot-scope="scope">
                        <div class="layerdata-item">
                            <div class="box">{{scope.row.layerdata.length>=i ? scope.row.layerdata[i-1].usercount : 'x'}}</div>
                            <div class="box">{{scope.row.layerdata.length>=i ? scope.row.layerdata[i-1].ordercount : 'x'}}</div>
                            <div class="box">{{scope.row.layerdata.length>=i ? scope.row.layerdata[i-1].orderrate : 'x'}}</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import LineReport from 'base/echarts/lineReport'
import {mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import {getDataStatisticsByLayer, exportDataStatisticsByLayer, getDataSummary} from 'api/nationalDistribution'
export default {
    name: 'fission',
    data() {
        return {
            init: false,
            tableData: [],
            summaryinfo: {
                begindate: '',
                enddate: '',
                maxlayer: '', // 最高裂变层级
                usercount: '', // 合计用户数
                ordercount: '' // 合计订单数
            },
            lineDatas: {id: 'fission', subText: '', xdata: [], data: [], legendAddr: 'left', formatter: '{a0}: {c0}<br />{a1}: {c1}'},
            date: [],
            datatype: 5, // 1用户统计 2订单统计 3财务统计 4分享统计 5裂变统计 6排行榜
            param: {
                timetype: 3, // 时间类型 0自定义 1今日 2昨日 3近7日 4近30日
                eventinnerid: '',
                begindate: '',
                enddate: ''
            },
            layerinfo: {
                totalordercount: '', // 订单总数
                uviewcount: '', // 参与人数UV
                maxlayer: '' // 裂变层级
            }
        }
    },
    mounted() {
    },
    methods: {
        handleQuery(index) {
            if (!index && !this.date.length) {
                this.$message.error('请选择筛选日期')
                return false
            } else if (!index && !!this.date.length) {
                this.param.begindate = this.date[0]
                this.param.enddate = this.date[1]
            }
            this.param.timetype = index
            this._getTotal()
        },
        getTotal(param) {
            this.param.eventinnerid = param.eventinnerid
            this._getTotal()
            if (!this.init) this._getDataSummary()
        },
        handleExport() {
            this.setLoading(true)
            exportDataStatisticsByLayer({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '裂变数据' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getTotal() {
            this.setLoading(true)
            getDataStatisticsByLayer({
                data: this.param,
                success: data => {
                    this.tableData = data.data.layerlist
                    this.summaryinfo = data.data.summaryinfo
                    let xdata = []
                    let [ydata1, ydata2] = [[], []]
                    data.data.datalist.forEach((obj) => {
                        xdata.push(obj.date)
                        ydata1.push(obj.usercount)
                        ydata2.push(obj.ordercount)
                    })
                    this.lineDatas.xdata = xdata
                    this.lineDatas.data=[]
                    this.lineDatas.data.push(
                        {
                            title: '用户数',
                            color: '#1989FA',
                            smooth: true,
                            symbol: 'circle',
                            list: ydata1
                        },
                        {
                            title: '订单数',
                            color: '#67C23A',
                            smooth: true,
                            symbol: 'circle',
                            list: ydata2
                        }
                    )
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getDataSummary() {
            getDataSummary({
                data: {eventinnerid: this.param.eventinnerid, datatype: this.datatype},
                success: data => {
                    this.init = true
                    this.layerinfo = data.data.layerinfo
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.fission{
    .layerdata-item{
        .box{
            padding: 12px 10px;
        }
        .box+.box{
            border-top: 1px solid $line;
        }
    }
    .el-table td{
        padding: 0 !important;
        .cell{
            padding: 0 !important;
        }
    }
}
</style>
